import React from 'react';
import { types as sdkTypes } from '../../util/sdkLoader';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import {
  LINE_ITEM_SHIPPING_FEE,
  LINE_ITEM_FREE_SHIPPING,
  LINE_ITEM_HANDLING_COST,
  propTypes,
} from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/** The order's shipping line: its shipping fee, else its free-shipping line (or none). */
export const shippingLineOf = lineItems =>
  lineItems.find(item => item.code === LINE_ITEM_SHIPPING_FEE && !item.reversal) ||
  lineItems.find(item => item.code === LINE_ITEM_FREE_SHIPPING && !item.reversal) ||
  null;

const LineItemShippingFeeMaybe = props => {
  const { lineItems, intl, isCustomer } = props;

  const shippingLineItem = shippingLineOf(lineItems);

  if (!shippingLineItem) return null;

  // For the buyer view, absorb the handling-cost line item into the
  // shipping number so they see a single "Shipping" total, free shipping
  // included. Provider-side accounting keeps the two as separate line items
  // (see LineItemHandlingCostMaybe).
  const handlingLineItem = isCustomer
    ? lineItems.find(item => item.code === LINE_ITEM_HANDLING_COST && !item.reversal)
    : null;

  const displayTotal = handlingLineItem
    ? new Money(
        (shippingLineItem.lineTotal.amount || 0) + (handlingLineItem.lineTotal.amount || 0),
        shippingLineItem.lineTotal.currency
      )
    : shippingLineItem.lineTotal;

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.shippingFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, displayTotal)}</span>
    </div>
  );
};

LineItemShippingFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemShippingFeeMaybe;
